/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputNews
 */
export interface OutputNews {
    /**
     * 
     * @type {string}
     * @memberof OutputNews
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputNews
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputNews
     */
    notifiedAt?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputNews
     */
    roles?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof OutputNews
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputNews
     */
    title?: string;
}

/**
 * Check if a given object implements the OutputNews interface.
 */
export function instanceOfOutputNews(value: object): boolean {
    return true;
}

export function OutputNewsFromJSON(json: any): OutputNews {
    return OutputNewsFromJSONTyped(json, false);
}

export function OutputNewsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputNews {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'id': json['id'] == null ? undefined : json['id'],
        'notifiedAt': json['notified_at'] == null ? undefined : json['notified_at'],
        'roles': json['roles'] == null ? undefined : json['roles'],
        'text': json['text'] == null ? undefined : json['text'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function OutputNewsToJSON(value?: OutputNews | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'created_at': value['createdAt'],
        'id': value['id'],
        'notified_at': value['notifiedAt'],
        'roles': value['roles'],
        'text': value['text'],
        'title': value['title'],
    };
}

